<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY<br/> <br/></span><span class="smallcaps">MASSIMO CARLOTTO</span></h1>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372051/the-goodbye-kiss" target="_blank">The Goodbye Kiss</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372181/death-s-dark-abyss" target="_blank">Death’s Dark Abyss</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372259/the-fugitive" target="_blank">The Fugitive</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372914/poisonville" target="_blank">Poisonville</a></em> (with Marco Videtta)</p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372808/bandit-love" target="_blank">Bandit Love</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781609451141/at-the-end-of-a-dull-day" target="_blank">At the End of a Dull Day</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781609452681/gang-of-lovers" target="_blank">Gang of Lovers</a></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// for-all-the-gold-in-the-world_00000.vue?472955b2